import { type FC } from 'react';

import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';
import { type BrandedSearchPageTemplate } from '@vakantiesnl/services/src/contentful/brandedSearchTemplate';

import { useStyles } from './BrandedSearchHeader.styles';
import { HeaderDescription } from '../../molecules/HeaderDescription';
import { HeaderImage } from '../../molecules/HeaderImage';

type Props = BrandedSearchPageTemplate & {
	readMoreRef: React.RefObject<HTMLDivElement>;
	className?: string;
};

export const BrandedSearchHeader: FC<Props> = ({
	title,
	headerImage,
	shortHeaderDescription,
	readMoreText,
	readMoreRef,
	readMoreLink,
	className,
}) => {
	const { classes, cx } = useStyles();
	const { isMobile } = useBreakpoints();

	return (
		<div className={cx(className)}>
			{isMobile && (
				<Typography
					as="h1"
					variant={!isMobile ? 'heading2Xl' : 'headingLg'}
					className={classes.title}
					id="searchPageTitle"
				>
					{title}
				</Typography>
			)}
			{!isMobile && (
				<>
					<div className={classes.headerContainer}>
						<Typography
							as="h1"
							variant={!isMobile ? 'heading2Xl' : 'headingLg'}
							className={cx(classes.title, classes.imageTitle)}
							id="searchPageTitle"
						>
							{title}
						</Typography>
						<HeaderImage
							className={classes.headerImage}
							imageSource={
								headerImage?.url || (process.env.NEXT_PUBLIC_DEFAULT_LISTER_BANNER_URL as string)
							}
							alt={headerImage?.title || title}
						/>
					</div>

					{shortHeaderDescription && (
						<HeaderDescription
							description={shortHeaderDescription}
							readMoreRef={readMoreRef}
							readMoreText={readMoreText}
							readMoreLink={readMoreLink}
						/>
					)}
				</>
			)}
		</div>
	);
};
